import { useNavigate } from 'react-router-dom'

import { Button, HStack } from '@chakra-ui/react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import QuotationButtonGroup from './QuotationButtonGroup'

//Slice
import { showAdminEditOfferModal } from '@/stores/offers/offersSlice'

import { authSelector } from '@/stores/auth/authSlice'
import { useConfirmationModalManagement } from '@/stores/ui/confirmationModalSlice'
import { offerActionGroupPolicyType } from '@/features/offers/constants/offerEditRights/offerActionEditRights'
import useOffer from '@/features/offers/hooks/useOffer'
import { selectOfferDetail, selectOfferPermissions } from '@/features/offers/slices/offerDetail.slice'
import ContributionButtonGroup from './ContributionButtonGroup'
import { PRApprovalStatus, PRStatus } from '@eapproval/offer-shared'
import BookingButtonGroup from './BookingButtonGroup'

const OfferFooter = ({ tabIndex, setTabIndex }) => {
  const offerPermissions = useSelector(selectOfferPermissions)
  const { adminMode } = useSelector(selectOfferDetail)

  const { user: currentUser } = useSelector(authSelector)

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { getValues, formState } = useFormContext()

  const costBudgets = useWatch({ name: 'sourcing.costBudgets' }) ?? []

  //Translated
  const canSave = offerPermissions[offerActionGroupPolicyType.ACTION_SAVE]?.edit ?? false

  const showPRApprovalButtons = costBudgets.some((costBudget) => {
    if (!Array.isArray(costBudget?.PR?.submissions)) return false

    return costBudget.PR.submissions.some((submission) => {
      if (!Array.isArray(submission?.approverDetails)) return false

      const approverDetail = submission.approverDetails.find((detail) => detail.user === currentUser._id)

      if (!approverDetail) return false

      return submission.status === PRStatus.SUBMITTED && approverDetail?.status === PRApprovalStatus.REQUIRED
    })
  })

  const handleGotoPRApproval = () => {
    let targetCostBudgetIndex = -1
    let targetSubmissionIndex = -1

    costBudgets.forEach((costBudget, costBudgetIndex) => {
      if (!Array.isArray(costBudget?.PR?.submissions)) return

      costBudget.PR.submissions.forEach((submission, submissionIndex) => {
        if (!Array.isArray(submission?.approverDetails)) return

        const approverDetail = submission.approverDetails.find((detail) => detail.user === currentUser._id)

        if (!approverDetail) return

        if (submission.status === PRStatus.SUBMITTED && approverDetail?.status === PRApprovalStatus.REQUIRED) {
          targetCostBudgetIndex = costBudgetIndex
          targetSubmissionIndex = submissionIndex
        }

        return
      })
    })

    if (targetCostBudgetIndex > -1 && targetSubmissionIndex > -1) {
      const offerId = getValues('_id')
      navigate(`/offers/${offerId}?costBudgetIndex=${targetCostBudgetIndex}&submissionIndex=${targetSubmissionIndex}`)
    }
  }

  const handleCancel = () => {
    navigate(-1)
  }

  const handleAdminEditStatus = () => {
    const offerId = getValues('_id')

    dispatch(
      showAdminEditOfferModal({
        offerId: offerId,
      })
    )
  }

  return (
    <>
      <HStack spacing="15px" position="fixed" bottom={0} w="100%" bg="white" py="5" zIndex={1000}>
        {canSave && (
          <Button colorScheme="blue" type="submit">
            Save
          </Button>
        )}
        <ContributionButtonGroup />
        <QuotationButtonGroup />
        <BookingButtonGroup tabIndex={tabIndex} setTabIndex={setTabIndex} />

        {showPRApprovalButtons && (
          <Button colorScheme="teal" onClick={() => handleGotoPRApproval()}>
            PR Approval
          </Button>
        )}

        <Button colorScheme="gray" onClick={handleCancel}>
          Cancel
        </Button>
        {adminMode && (
          <Button colorScheme="gray" onClick={handleAdminEditStatus}>
            Change Status
          </Button>
        )}
      </HStack>
    </>
  )
}

export default OfferFooter
